import { Controller } from '@hotwired/stimulus'

// Scales fixed-width content down so it fits its container.
// CSS `zoom` combined with container-query math is ignored by Safari, so the
// scaling has to be computed here to keep the layout identical across browsers.
export default class extends Controller {
  static targets = ['content']

  connect () {
    this.observer = new window.ResizeObserver(() => this.#scale())
    this.observer.observe(this.element)
    this.#scale()
  }

  disconnect () {
    this.observer?.disconnect()
    this.observer = null
    this.lastWidth = null
  }

  // Guarded against the height we set feeding back into the observer.
  #scale () {
    const available = this.element.clientWidth
    const intrinsic = this.contentTarget.offsetWidth

    if (!available || !intrinsic || available === this.lastWidth) return

    this.lastWidth = available
    const ratio = Math.min(1, available / intrinsic)

    this.contentTarget.style.transform = `scale(${ratio})`
    this.element.style.height = `${this.contentTarget.offsetHeight * ratio}px`
  }
}
